module.exports = __webpack_public_path__ + "img/apoc_apocalyptics.cce48a2.png";